import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import { ProjectDetails } from "../../../features/project-details/ProjectDetails";
import ReleasePreview from "./ReleasePreview";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

import { CategoryState } from "../../../utils/CategoryState";
import { RequestState } from "../../../utils/RequestState";
import {
  useApproveProject,
  useGetProjectAdmin,
} from "../../../utils/useProject";

type Props = {
  isSelect: boolean;
};

export const ReleaseProjectPreviewContainer: React.FC<Props> = ({
  isSelect,
}) => {
  const { id } = useParams<{ id: string }>();

  const [activeModal, setActiveModal] = useState<CategoryState>(
    CategoryState.None
  );
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Pending
  );
  const [message, setMessage] = useState<string>("");
  const [imgs, setImgs] = useState<Array<string>>();

  const auth_token = useAppSelector(getAuthToken);

  const queryKey = {
    auth_token: auth_token,
    is_jikei_request: !isSelect,
    id,
  };

  const {
    items: { projects },
    isLoading,
  } = useGetProjectAdmin(queryKey, auth_token ? true : false);
  const project = projects[0];

  const { mutateAsync, mutateLoading } = useApproveProject([
    "projectAdmin",
    queryKey,
  ]);

  const handleInputChange = (value: string) => {
    setMessage(value);
  };

  const showModal = (modal: CategoryState) => {
    setActiveModal(modal);
  };

  const closeModal = () => {
    setActiveModal(CategoryState.None);
    setRequestState(RequestState.Pending);
  };

  const handleSubmit = async (approve: boolean) => {
    if (auth_token && id) {
      setRequestState(RequestState.Doing);

      await mutateAsync({
        auth_token,
        id,
        message,
        approve,
        is_jikei_request: !isSelect,
      });

      setRequestState(RequestState.Success);
    }
  };

  useEffect(() => {
    if (isLoading) return;

    if (project?.id === id && project?.imgs) {
      const img: Array<string> = [];
      project.imgs?.map((value) => {
        img.push(value.large.url);
      });

      setImgs(img);
    }
  }, [isLoading]);

  return (
    <ReleasePreview
      message={message}
      targetName={`${project?.name} `}
      modalLink={`/project/${id}`}
      activeModal={activeModal}
      requestState={requestState}
      closeModal={closeModal}
      showModal={showModal}
      handleSubmit={handleSubmit}
      handleInputChange={handleInputChange}
      isLoading={isLoading || mutateLoading}
      confirmations={project?.confirmations}
      releaseType={`プロジェクト名`}
    >
      <ProjectDetails
        id={project?.id}
        title={project?.name}
        type={project?.type}
        ownerId={project?.owner}
        ownerName={project?.owner_name}
        ownerChatDenial={project?.owner_chat_denial}
        question={project?.confirmations}
        imgs={imgs}
        applicants={project?.applicants}
        end_date={project?.end_date}
        game={project?.game}
        description={project?.description}
        requirements={project?.requirements}
        isUserLoggedIn={false}
        isUsersOwnProject={true}
        isUserApplied={true}
        isJikei={
          project?.role_restriction?.includes("jikei_student") ? true : false
        }
      />
    </ReleasePreview>
  );
};
